import jsPDF from 'jspdf';
import 'jspdf-autotable';

const getCajaAdelanto = (adelanto) => {
  const caja = adelanto?.caja;

  if (!caja) return "-";

  if (typeof caja === "object") {
    return caja.descripcion || caja.nombre || caja.detalle || "-";
  }

  return "-";
};

export const generarPDFviajeConDetalles = (v, comandasAsociadas = []) => {
  const doc = new jsPDF();
  let y = 10;
  const resumen = calcularResumen(v);
  const rentabilidad = calcularRentabilidad(v, comandasAsociadas, resumen);

  doc.setFontSize(14);
  doc.text(`Viaje Nro ${v.nroViaje}`, 14, y);
  y += 8;

  doc.setFontSize(10);
  doc.text(`Chofer: ${v.choferId?.nombre || '-'}`, 14, y);
  y += 5;
  doc.text(
    `Camión: ${
      v.camionId
        ? `${v.camionId.camion || ''} (${v.camionId.patente || ''})`
        : '-'
    }`,
    14,
    y
  );
  y += 5;
  doc.text(`Tarifa por KM: $${v.tarifaPorKm}`, 14, y);
  y += 5;
  doc.text(`Fecha Comanda: ${v.comandaId?.fecha?.substring(0, 10) || '-'}`, 14, y);
  y += 7;

  const agregarTabla = (titulo, columnas, filas) => {
    doc.setFontSize(11);
    doc.text(titulo, 14, y);
    y += 4;

    doc.autoTable({
      startY: y,
      head: [columnas],
      body: filas,
      styles: { fontSize: 8, cellPadding: 1 },
      headStyles: { fillColor: [60, 60, 60], textColor: 255 },
      margin: { left: 10, right: 10 },
    });

    y = doc.lastAutoTable.finalY + 6;
  };

  if (v.tramos?.length) {
    agregarTabla(
      'Tramos',
      ['Fecha', 'Origen', 'Destino', 'Remito'],
      v.tramos.map((t) => [
        t.fecha?.substring(0, 10) || '',
        t.origen,
        t.destino,
        t.remito,
      ])
    );
  }

  if (v.combustible?.length) {
    const combustibleConConsumo = calcularConsumoPorTramo(v.combustible);

    agregarTabla(
      'Combustible',
      ['Fecha', 'Litros', 'Monto', 'Pago', 'Estación', 'Localidad', 'Km Tablero', 'Km/L Tramo'],
      combustibleConConsumo.map((c) => [
        c.fecha?.substring(0, 10) || '',
        c.litros,
        `$${c.monto}`,
        c.metodoPago || '-',
        typeof c.estacion === 'object'
          ? c.estacion.estacion
          : (v.estaciones?.find((e) => e._id === c.estacion)?.estacion ||
             c.estacion ||
             '-'),
        c.localidad || '-',
        c.kmTablero ?? '',
        c.consumoTramo,
      ])
    );
  }

  [
    { titulo: 'Viáticos', data: v.viaticos },
    { titulo: 'Adelantos', data: v.adelantos },
    { titulo: 'Gastos', data: v.gastos },
  ].forEach(({ titulo, data }) => {
    if (data?.length) {
      if (titulo === "Adelantos") {
        agregarTabla(
          titulo,
          ['Descripción', 'Caja', 'Monto'],
          data.map((d) => [
            d.descripcion || "-",
            getCajaAdelanto(d),
            Number(d.monto || 0).toLocaleString('es-AR', {
              style: 'currency',
              currency: 'ARS',
            }),
          ])
        );
      } else {
        agregarTabla(
          titulo,
          ['Descripción', 'Monto'],
          data.map((d) => [
            d.descripcion || "-",
            Number(d.monto || 0).toLocaleString('es-AR', {
              style: 'currency',
              currency: 'ARS',
            }),
          ])
        );
      }
    }
  });

  agregarTabla('Resumen Final', ['Concepto', 'Monto'], [
    ['Total Km Recorrido', resumen.totalKm],
    ['Valor Km a pagar chofer', resumen.valorKm.toLocaleString('es-AR', { style: 'currency', currency: 'ARS' })],
    ['Total a Pagar a chofer', resumen.valorViaje.toLocaleString('es-AR', { style: 'currency', currency: 'ARS' })],
    ['Total Combustible', resumen.totalCombustible.toLocaleString('es-AR', { style: 'currency', currency: 'ARS' })],
    ['Litros Cargados', resumen.totalLitros],
    ['Promedio de Consumo', `${resumen.promedioConsumo} km/L`],
    ['Viáticos', resumen.totalViaticos.toLocaleString('es-AR', { style: 'currency', currency: 'ARS' })],
    ['Adelantos', resumen.totalAdelantos.toLocaleString('es-AR', { style: 'currency', currency: 'ARS' })],
    ['Gastos', resumen.totalGastos.toLocaleString('es-AR', { style: 'currency', currency: 'ARS' })],
    ['💰 Total a Cobrar', resumen.liquidacionFinal.toLocaleString('es-AR', { style: 'currency', currency: 'ARS' })],
  ]);

  /* =========================
     SEGUNDA HOJA: RENTABILIDAD
  ========================= */
  if (rentabilidad.detalleIngresos.length) {
    doc.addPage();
    y = 10;

    doc.setFontSize(14);
    doc.text(`Rentabilidad del Viaje ${v.nroViaje}`, 14, y);
    y += 8;

    doc.setFontSize(10);
    doc.text(`Chofer: ${v.choferId?.nombre || '-'}`, 14, y);
    y += 5;
    doc.text(
      `Camión: ${
        v.camionId
          ? `${v.camionId.camion || ''} (${v.camionId.patente || ''})`
          : '-'
      }`,
      14,
      y
    );
    y += 8;

    const filasIngresos = rentabilidad.detalleIngresos.map((c) => [
      c.nroViaje || '-',
      c.codcom || '-',
      c.cliente || '-',
      c.pactado.toLocaleString('es-AR', {
        style: 'currency',
        currency: 'ARS',
      }),
    ]);

    agregarTabla(
      'Ingresos del Viaje',
      ['Nro Viaje', 'Comanda', 'Cliente', 'Pactado'],
      filasIngresos
    );

    agregarTabla('Resumen Económico', ['Concepto', 'Monto'], [
      ['Ingresos Totales', rentabilidad.ingresos.toLocaleString('es-AR', { style: 'currency', currency: 'ARS' })],
      ['Combustible', rentabilidad.totalCombustible.toLocaleString('es-AR', { style: 'currency', currency: 'ARS' })],
      ['Valor del Viaje', rentabilidad.valorViaje.toLocaleString('es-AR', { style: 'currency', currency: 'ARS' })],
      ['Viáticos', rentabilidad.totalViaticos.toLocaleString('es-AR', { style: 'currency', currency: 'ARS' })],
      ['Gastos', rentabilidad.totalGastos.toLocaleString('es-AR', { style: 'currency', currency: 'ARS' })],
      ['Costos Totales', rentabilidad.costos.toLocaleString('es-AR', { style: 'currency', currency: 'ARS' })],
      ['UTILIDAD', rentabilidad.utilidad.toLocaleString('es-AR', { style: 'currency', currency: 'ARS' })],
      ['Margen', `${rentabilidad.margen}%`],
    ]);
  }

  doc.save(`Viaje-${v.nroViaje}.pdf`);
};

function calcularConsumoPorTramo(combustible = []) {
  return combustible.map((c, index, arr) => {
    if (index === 0) {
      return { ...c, consumoTramo: '-' };
    }

    const kmActual = Number(c.kmTablero || 0);
    const kmAnterior = Number(arr[index - 1]?.kmTablero || 0);
    const litros = Number(c.litros || 0);
    const kmRecorridos = kmActual - kmAnterior;

    let consumoTramo = '-';
    if (litros > 0 && kmRecorridos > 0) {
      consumoTramo = `${(kmRecorridos / litros).toFixed(2)} km/L`;
    }

    return { ...c, consumoTramo };
  });
}

function calcularResumen(v) {
  const kmTableros = (v.combustible || [])
    .map((c) => Number(c.kmTablero))
    .filter((km) => !isNaN(km));

  const totalKm =
    kmTableros.length >= 2 ? Math.max(...kmTableros) - Math.min(...kmTableros) : 0;

  const tarifa = Number(v.tarifaPorKm || 130);
  const totalLitros = (v.combustible || []).reduce((sum, c) => sum + Number(c.litros), 0);
  const totalCombustible = (v.combustible || []).reduce((sum, c) => sum + Number(c.monto), 0);
  const totalViaticos = (v.viaticos || []).reduce((sum, x) => sum + Number(x.monto), 0);
  const totalAdelantos = (v.adelantos || []).reduce((sum, x) => sum + Number(x.monto), 0);
  const totalGastos = (v.gastos || []).reduce((sum, x) => sum + Number(x.monto), 0);

  const promedioConsumo = totalLitros > 0 ? (totalKm / totalLitros).toFixed(2) : '-';
  const liquidacionFinal1 = (totalKm * tarifa) + totalViaticos;
  const liquidacionFinal2 = totalAdelantos - totalGastos;
  const liquidacionFinal = liquidacionFinal1 - liquidacionFinal2;

  return {
    totalKm,
    totalLitros,
    promedioConsumo,
    totalCombustible,
    totalViaticos,
    totalAdelantos,
    totalGastos,
    liquidacionFinal,
    valorKm: tarifa,
    valorViaje: totalKm * tarifa,
  };
}

function calcularRentabilidad(v, comandasAsociadas = [], resumen) {
  const detalleIngresos = (comandasAsociadas || []).map((c) => ({
    nroViaje: c.nroviaje || c.nroViaje || '-',
    codcom: c.codcom || c.nrodecomanda || '-',
    cliente:
      c.cliente?.razonsocial ||
      c.cliente?.nombre ||
      c.razonsocial ||
      '-',
    pactado: Number(c.pactadoter || c.pactadoTercero || c.pactado || c.total || 0),
  }));

  const ingresos = detalleIngresos.reduce((sum, c) => sum + c.pactado, 0);

  const costos =
    Number(resumen.totalCombustible || 0) +
    Number(resumen.valorViaje || 0) +
    Number(resumen.totalViaticos || 0) +
    Number(resumen.totalGastos || 0);

  const utilidad = ingresos - costos;
  const margen = ingresos > 0 ? ((utilidad / ingresos) * 100).toFixed(2) : '0.00';

  return {
    detalleIngresos,
    ingresos,
    totalCombustible: Number(resumen.totalCombustible || 0),
    valorViaje: Number(resumen.valorViaje || 0),
    totalViaticos: Number(resumen.totalViaticos || 0),
    totalGastos: Number(resumen.totalGastos || 0),
    costos,
    utilidad,
    margen,
  };
}